import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/index';  
import contentReducer from './reducers/index';

const store = configureStore({
  reducer: userReducer, contentReducer

});

export default store;